import store from 'Store';
import { userEmailVerified } from 'Api/user';

function onUserEmailVerified() {
  // send to backend that user verified his email
  userEmailVerified();
  // show success message, but with timeout to wait for page loaded
  setTimeout(() => {
    store.dispatch('toaster/setMessage', {
      text: 'Email verified!',
      options: {
        type: 'success',
      },
    });
  }, 5000);
  return ({ name: 'account' });
}

// Check is it verification email redirect
function checkUserEmailVerified(to) {
  const { emailVerified } = to.query;
  // If there is emailVerified param, means user just redirected from email verification process
  if (emailVerified) {
    return onUserEmailVerified();
  }
  return true;
}

async function registerStoreModule() {
  const { default: storeModule } = await import(/* webpackChunkName: 'storeModuleProfileSettings' */ '../store');
  if (!store.hasModule('profile-settings')) {
    store.registerModule('profile-settings', storeModule);
  }
}

export default [
  {
    path: '/profile/settings/login-credentials',
    redirect: { name: 'settings' },
  },
  {
    path: '/profile/settings/security',
    redirect: { name: 'settings' },
  },
  {
    path: '/profile/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: 'PageProfileSettings' */ '../PageProfileSettings'),
    async beforeEnter(to, from, next) {
      // Check is it redirect from an email verification process.
      // If yes, the function returns a new route.
      const result = checkUserEmailVerified(to);
      await registerStoreModule();
      // Pass new route for redirect or true for continue
      next(result);
    },
    meta: {
      requiresAuth: true,
      store: ['profile-settings/getLoginHistoryData'],
    },
  },
];
